import React, { useContext } from "react";
import { IntlContext } from "context";
import { useField } from "react-final-form";
import ReferenceField from "components/Form/Field/ReferenceField";
import { SubCategory } from "types/subCategory";

interface Props {
    disabled: boolean;
}

const TutoringFields: React.FC<Props> = ({ disabled }) => {
    const intl = useContext(IntlContext);
    const subcategory = useField("subcategory");

    return (
        <>
            {[SubCategory.HOMEWORK].includes(subcategory.input.value) && (
                <div className="margin-top--4 space-y-6">
                    <ReferenceField
                        variant="chips"
                        refType="scholar_subject"
                        inputProps={{
                            name: "data.scholar_subjects",
                            required: true,
                            disabled: disabled,
                            multiple: true,
                        }}
                        labelProps={{
                            label: intl.formatMessage("service.label.subject"),
                        }}
                    />
                    <ReferenceField
                        variant="chips"
                        refType="scholar_level"
                        inputProps={{
                            name: "data.academic_level",
                            required: true,
                            disabled: disabled,
                            multiple: true,
                        }}
                        labelProps={{
                            label: intl.formatMessage("service.label.academic_level"),
                        }}
                    />
                </div>
            )}
            {[SubCategory.FOREIGN_LANGUAGES].includes(subcategory.input.value) && (
                <div className="margin-top--4">
                    <ReferenceField
                        variant="chips"
                        refType="foreign_languages"
                        inputProps={{
                            name: "data.foreign_languages",
                            required: true,
                            disabled: disabled,
                            multiple: true,
                        }}
                        labelProps={{
                            label: intl.formatMessage("service.label.foreign_languages"),
                        }}
                    />
                </div>
            )}
            {[SubCategory.OTHER_LESSON].includes(subcategory.input.value) && (
                <div className="margin-top--4">
                    <ReferenceField
                        variant="chips"
                        refType="activity"
                        inputProps={{
                            name: "data.activities",
                            required: true,
                            disabled: disabled,
                            multiple: true,
                        }}
                        labelProps={{
                            label: intl.formatMessage("service.label.activity"),
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default TutoringFields;
